/** 区分「编辑回填首次写入」与「用户切换镜像」：仅在后一种情况返回 true */
export function createImageKeySwitchTracker() {
  const previousByForm = new WeakMap<object, string | undefined>();

  return {
    consumeImageSwitch(form: object, nextKey: string | undefined): boolean {
      const normalized = nextKey?.trim() || undefined;
      const previous = previousByForm.get(form);
      const switched = previous !== undefined && previous !== normalized;
      previousByForm.set(form, normalized);
      return switched;
    },
  };
}
